export default "__VITE_ASSET__CnhcAqNa__"